// Mac and Windows ship separately, so each names its own version.
export const desktopRelease = {
  version: "0.1.38",
  arm64: "https://stone-updates.logic-gate-catalog.workers.dev/stable/desktop/arm64/Stone-0.1.38-arm64.dmg",
  x64: "https://stone-updates.logic-gate-catalog.workers.dev/stable/desktop/x64/Stone-0.1.38-x64.dmg",
  windowsVersion: "0.1.36",
  windows: "https://stone-updates.logic-gate-catalog.workers.dev/stable/desktop/win/x64/Stone-0.1.36-x64.exe",
} as const;
